import React, { forwardRef, useState, useContext } from 'react'
import {
  Dialog,
  DialogContent,
  IconButton,
  Grow,
  Box,
  Typography,
  Icon,
  Button,
  CircularProgress,
} from '@mui/material'
import { motion } from 'framer-motion'
import {
  AccountBalance,
  Home,
  Moving,
  Edit,
  ArrowBack,
  Close,
  Savings,
  EventAvailable,
  FlightTakeoff,
  Paid,
  Help,
  School,
  CarRental,
  CreditCard,
  Work,
  HealthAndSafety,
  Flag,
  AssuredWorkload,
  HistoryEdu,
} from '@mui/icons-material'
import signalLogo from 'assets/images/logos/signalLogo.png'
import parcoLogo from 'assets/images/parco-white.png'

import { useQuilttIntegration } from 'hooks/useQuilttIntegration'
import { QuilttButton } from '@quiltt/react'
import { AnimatePresence } from 'framer-motion'
import { NewBalanceSheetModalForm } from 'layouts/authenticated/pages/newdash/components/NewBalanceSheetModalForm'
import { useApi } from 'hooks/useApi'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import { selectData } from 'layouts/onboarding'
import { IntakeContext } from 'context/IntakeContext'
const Transition = forwardRef(function Transition(props, ref) {
  return <Grow timeout={300} ref={ref} {...props} />
})

import { styled } from '@mui/material/styles'

const TileBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ active }) => ({
  cursor: 'pointer',
  width: '100%',
  height: '100%',
  borderRadius: '6px',
  border: '1.5px solid #e5e5e5',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: active ? '#eeeeee' : '#fff',
  transition: '0.2s all ease-in-out',

  '&:hover': {
    border: '1.5px solid #a3a7aa',
    backgroundColor: '#f5f5f5',
  },
}))

const iconCircleStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#f9f9f9',
  borderRadius: 200,
  padding: 1,
  mb: 1,
}

export default function AddAccounts({
  isAdmin = false,
  onClose,
  openToPage = 0,
  getAccounts = () => {
    console.log('nothing')
  },
  startingType = '',
}) {
  const { refreshQuiltt, handleExitSuccess } = useQuilttIntegration(() => {
    console.log('Accounts updated!')
    getAccounts()
  }, onClose)
  const { intakeState } = useContext(IntakeContext)
  const isGovernmentEmployee = intakeState?.governmentEmployee

  // console.log(openToPage)

  const openTo =
    openToPage[0] === undefined
      ? openToPage
      : openToPage[0] === 'A'
      ? 1
      : openToPage[0] === 'L'
      ? 2
      : openToPage[0] === 'I'
      ? 6
      : openToPage[0] === 'E'
      ? 6
      : openToPage[0] === 'D'
      ? 13
      : openToPage[0] === 'T'
      ? 14
      : 1

  // console.log(openTo)

  // console.log('openTo', openTo)
  const startingPage = openTo // > 5 ? openTo : 0

  // console.log(startingPage)

  const [page, setPage] = useState(startingPage)
  const [direction, setDirection] = useState(1)

  const [type, setType] = useState(startingType)
  const [subType, setSubType] = useState('')
  const [amount, setAmount] = useState()
  const [name, setName] = useState()

  const [open, setOpen] = useState(false)
  const [id, setId] = useState()
  const [version, setVersion] = useState()
  const [plaidName, setPlaidName] = useState()
  const [sortKey, setSortKey] = useState()
  const [subTypeClassification, setSubTypeClassification] = useState()
  const [interestRate, setInterestRate] = useState()
  const [monthlyPayment, setMonthlyPayment] = useState()
  const [frequency, setFrequency] = useState('monthly')
  const [ieStartDate, setIeStartDate] = useState()
  const [policyNumber, setPolicyNumber] = useState()
  const [balance, setBalance] = useState()
  const [loanEndDate, setLoanEndDate] = useState()
  const [keepInRetirement, setKeepInRetirement] = useState()
  const [canEdit, setCanEdit] = useState(false)
  const [signalForm, setSignalForm] = useState(false)
  const [signalLinked, setSignalLinked] = useState(false)
  const [signalError, setSignalError] = useState(false)
  const [issueDate, setIssueDate] = useState()
  const [anniversaryDate, setAnniversaryDate] = useState()
  const [carrier, setCarrier] = useState()
  const [product, setProduct] = useState()

  const handleNext = () => {
    setDirection(1)
    setPage((prev) => Math.min(prev + 1, pages.length - 1))
  }
  const handleBack = () => {
    if (page == 2) {
      setDirection(-1)
      setPage(0)
      return
    }
    if (page == 3) {
      setDirection(-1)
      type === 'asset' ? setPage(1) : setPage(2)
      return
    }
    if (page == 4 && subType === 'property') {
      setDirection(-1)
      setPage(1)
      return
    }
    if (page == 5) {
      setDirection(-1)
      setPage(3)
      return
    }
    if (page == 9) {
      setDirection(-1)
      setPage(6)
      return
    }
    setDirection(-1)
    setPage((prev) => Math.max(prev - 1, 0))
  }

  const handleClose = () => {
    setOpen(false)
    setVersion('')
    setId('')
    setType('')
    setName('')
    setPlaidName('')
    setSubType('')
    setAmount('')
    setSortKey('')
    setSubTypeClassification('')
    setInterestRate('')
    setMonthlyPayment('')
    setFrequency('')
    setLoanEndDate('')
    setIeStartDate('')
    setPolicyNumber('')
    setBalance('')
    setIssueDate('')
    setCarrier('')
    setProduct('')
    setAnniversaryDate('')
    setSignalForm(false)
    setSignalError(false)
    setSignalLinked(false)
    onClose()
  }

  const handleResetForm = () => {
    setCanEdit(false)
    setVersion('')
    setId('')
    setName('')
    setPlaidName('')
    setSubType('')
    setAmount('')
    setSortKey('')
    setSubTypeClassification('')
    setInterestRate('')
    setMonthlyPayment('')
    setFrequency('')
    setLoanEndDate('')
    setIeStartDate('')
    setPolicyNumber('')
    setBalance('')
    setIssueDate('')
    setCarrier('')
    setProduct('')
    setSignalForm(false)
    setSignalError(false)
    setSignalLinked(false)
  }

  const handleReload = () => {
    getAccounts()
  }

  const variants = {
    enter: (dir) => ({
      x: dir > 0 ? 300 : -300,
      opacity: 0,
    }),
    center: {
      x: 0,
      opacity: 1,
    },
    exit: (dir) => ({
      x: dir > 0 ? -300 : 300,
      opacity: 0,
    }),
  }

  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState()
  const { apiRequest } = useApi()
  const [localForm, setLocalForm] = useState({
    policyNumber: '',
  })

  const handleChange = (field) => (value) => {
    setLocalForm((prev) => ({ ...prev, [field]: value }))
  }

  const getSignalPolicyInfo = async () => {
    setIsLoading(true)
    setSignalForm(true)

    try {
      // const res = await apiRequest('/api/quiltt/signalBigQueryRequest', {
      //   method: 'POST',
      //   body: JSON.stringify({ policyNumber: localForm.policyNumber }),
      // })

      const res = await apiRequest('/api/quiltt/signalAssetRequest', {
        method: 'POST',
        body: JSON.stringify({ policyNumber: policyNumber }),
      })

      // console.log(res)
      const data = await res.json()
      setData(data)
      console.log('data', data)

      if (!res.ok || !data) {
        setSignalForm(false)
        setSignalError(true)
        throw new Error(data.message || 'Failed to fetch policy information')
      }

      const inforce = data.inforceResults?.[0] || {}
      const application = data.applicationResults?.[0] || {}

      const amount = Number(inforce.accumulation_value)
      setAmount(isNaN(amount) ? null : amount)
      setCarrier(
        selectData.annuityCarriers.find(
          ({ label }) => label === application.carrier_name
        )?.value || null
      )
      setProduct(
        selectData.annuityOptions.find(
          ({ label }) => label === application.product_name
        )?.value || null
      )
      setIssueDate(application.policy_issued_date.value || null)
      setAnniversaryDate(application.inforce_date.value || null)
      setName(`${application.carrier_name} - ${application.product_name}`)
      setType('assetIncome')
      setSignalLinked(true)
    } catch (error) {
      setSignalForm(false)
      setSignalError(true)
      console.error('Error fetching policy information:', error)
    }
    setIsLoading(false)
    setPage(4)
  }

  const pages = [
    // ASSET OR LIABILITY
    <Box key="0" sx={{ padding: { xs: 2, md: 6, lg: 6 } }}>
      <Box sx={{}}>
        <Typography variant={'headerTitle'} color={'#262627'}>
          Is your account an Asset or a Liability
        </Typography>
      </Box>
      <Box sx={{ marginTop: { xs: 2, md: 6 } }}>
        <Typography variant={'body1'} color={'#495057'}>
          Select one of the following:
        </Typography>
      </Box>
      <Box mt={4}>
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            textAlign: 'center',
          }}
        >
          <TileBox
            onClick={() => {
              handleNext()
            }}
          >
            <Box
              className="icon-circle"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#f9f9f9',
                borderRadius: 200,
                padding: 1,
                mb: 1,
              }}
            >
              <Icon aria-label="institution" fontSize="large">
                <Savings sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant={'body3Weird'} color={'#262627'}>
              Asset
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setDirection(1)
              setPage(2)
            }}
          >
            <Box
              className="icon-circle"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#f9f9f9',
                borderRadius: 200,
                padding: 1,
                mb: 1,
              }}
            >
              <Icon aria-label="institution" fontSize="large">
                <EventAvailable sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant={'body3Weird'} color={'#262627'}>
              Liability
            </Typography>
          </TileBox>
        </Box>
      </Box>
    </Box>,
    // ASSET TYPES
    <Box key="1" sx={{ padding: { xs: 1, md: 6, lg: 6 } }}>
      <Box sx={{}}>
        <Typography variant={'headerTitle'} color={'#262627'}>
          Add Asset
        </Typography>
      </Box>
      <Box sx={{ marginTop: { xs: 1, md: 4 } }}>
        <Typography variant={'body1'} color={'#495057'}>
          Select which Asset type you want to add:
        </Typography>
      </Box>
      <Box mt={4}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'repeat(2, 1fr)',
              md: 'repeat(3, 1fr)',
            },
            gap: 1,
            textAlign: 'center',
          }}
        >
          <TileBox
            onClick={() => {
              setType('asset')
              setSubType('checkingsavings')
              setSubTypeClassification('checkingaccount')
              setName('Checking Account')
              setDirection(1)
              setPage(3)
            }}
          >
            <Box className="icon-circle" sx={{ ...iconCircleStyle }}>
              <Icon aria-label="institution" fontSize="large">
                <AccountBalance sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant={'body3Weird'} color={'#262627'}>
              Checking
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('asset')
              setSubType('checkingsavings')
              setSubTypeClassification('savingsaccount')
              setName('Savings Account')
              setDirection(1)
              setPage(3)
            }}
          >
            <Box className="icon-circle" sx={{ ...iconCircleStyle }}>
              <Icon aria-label="institution" fontSize="large">
                <Savings sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant={'body3Weird'} color={'#262627'}>
              Savings
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('asset')
              setSubType('property')
              setSubTypeClassification('primaryresidence')
              setName('Primary Residence')
              setDirection(1)
              setPage(4)
            }}
          >
            <Box className="icon-circle" sx={{ ...iconCircleStyle }}>
              <Icon aria-label="institution" fontSize="large">
                <Home sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant={'body3Weird'} color={'#262627'}>
              Property
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('asset')
              setSubType('investment')
              setSubTypeClassification('')
              setDirection(1)
              setPage(3)
            }}
          >
            <Box className="icon-circle" sx={{ ...iconCircleStyle }}>
              <Icon aria-label="institution" fontSize="large">
                <FlightTakeoff sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant={'body3Weird'} color={'#262627'}>
              {isGovernmentEmployee ? 'TSP/401k/IRA' : '401k/IRA'}
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('assetIncome')
              setSubType('investment')
              setSubTypeClassification('annuity')
              setDirection(1)
              {
                isAdmin ? setPage(11) : setPage(3)
              }
            }}
          >
            <Box className="icon-circle" sx={{ ...iconCircleStyle }}>
              <Icon aria-label="institution" fontSize="large">
                <AssuredWorkload sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant={'body3Weird'} color={'#262627'}>
              Annuity
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('asset')
              setSubType('otherassets')
              setSubTypeClassification('')
              setDirection(1)
              setPage(3)
            }}
          >
            <Box className="icon-circle" sx={{ ...iconCircleStyle }}>
              <Icon aria-label="institution" fontSize="large">
                <Paid sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant={'body3Weird'} color={'#262627'}>
              Other Assets
            </Typography>
          </TileBox>
        </Box>
        <Box mt={3}>
          <Button
            variant="parcoRounded"
            color="outline"
            onClick={() => {
              setPage(2)
            }}
          >
            Add a Liability Instead
          </Button>
        </Box>
      </Box>
    </Box>,
    // LIABILITY TYPES
    <Box key="2" sx={{ padding: { xs: 1, md: 6, lg: 6 } }}>
      <Box>
        <Typography variant={'headerTitle'} color={'#262627'}>
          Add Liability
        </Typography>
      </Box>
      <Box sx={{ marginTop: { xs: 1, md: 4 } }}>
        <Typography variant={'body1'} color={'#495057'}>
          Select which Liability type you want to add:
        </Typography>
      </Box>
      <Box mt={4}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
            gap: 1,
            textAlign: 'center',
          }}
        >
          <TileBox
            onClick={() => {
              setType('liability')
              setSubType('creditcard')
              setSubTypeClassification('creditcard')
              setName('Credit Card')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="creditcard" fontSize="large">
                <CreditCard sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Credit Card
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('liability')
              setSubType('otherliabilities')
              setSubTypeClassification('autoloan')
              setName('Auto Loan')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="autoloan" fontSize="large">
                <CarRental sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Auto Loan
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('liability')
              setSubType('otherliabilities')
              setSubTypeClassification('personalloan')
              setName('Personal Loan')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="personalloan" fontSize="large">
                <Paid sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Personal Loan
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('liability')
              setSubType('otherliabilities')
              setSubTypeClassification('privatestudentloan')
              setName('Student Loan')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="studentloan" fontSize="large">
                <School sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Student Loan
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('liability')
              setSubType('mortgage')
              setSubTypeClassification('primarymortgage')
              setName('Primary Mortgage')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="mortgage" fontSize="large">
                <Home sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Mortgage
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('liability')
              setSubType('otherliabilities')
              setSubTypeClassification('')
              setName('')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="otherliabilities" fontSize="large">
                <Help sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Other Liabilities
            </Typography>
          </TileBox>
        </Box>
        <Box mt={3}>
          <Button
            variant="parcoRounded"
            color="outline"
            onClick={() => {
              setPage(1)
            }}
          >
            Add an Asset Instead
          </Button>
        </Box>
      </Box>
    </Box>,
    // LINK ACCOUNT OR ADD MANUALLY
    <Box key="3" sx={{ padding: { xs: 2, md: 6, lg: 6 } }}>
      <Box sx={{}}>
        <Typography variant={'headerTitle'} color={'#262627'}>
          Would you like to link this account for live updates?
        </Typography>
      </Box>
      <Box sx={{ marginTop: { xs: 1, md: 4 } }}>
        <Typography variant={'body1'} color={'#495057'}>
          Enter account info manually, or link your account so that your numbers
          are always up to date! Select ond of the following:
        </Typography>
      </Box>
      <Box mt={4}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'repeat(2, 1fr)',
              md: 'repeat(2, 1fr)',
            },
            gap: 1,
            mb: 1,
            textAlign: 'center',
          }}
        >
          <TileBox
            component={QuilttButton}
            connectorId="5ugr9q35ag"
            onExitSuccess={handleExitSuccess}
          >
            <Box
              className="icon-circle"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#2370ED',
                height: '52px',
                width: '52px',
                borderRadius: 200,
                padding: '2px',
                mb: 1,
              }}
            >
              <img
                src={parcoLogo}
                style={{
                  width: '48px',
                  height: 'auto',
                }}
              />
            </Box>
            <Typography variant={'body3Weird'} color={'#262627'}>
              Link with PARCO
            </Typography>
          </TileBox>
          <TileBox
            onClick={() => {
              type === 'asset' ? handleNext() : setPage(5)
            }}
          >
            <Box
              className="icon-circle"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#f9f9f9',
                borderRadius: 200,
                padding: 1,
                mb: 1,
              }}
            >
              <Icon aria-label="institution" fontSize="large">
                <Edit sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant={'body3Weird'} color={'#262627'}>
              Enter Manually
            </Typography>
          </TileBox>
        </Box>
      </Box>
    </Box>,
    // ASSET NO EDIT
    <Box key="4" sx={{ padding: { xs: 1, md: 6, lg: 6 } }}>
      {subTypeClassification === 'annuity' ? (
        <>
          {signalForm ? (
            <>
              <Box sx={{}}>
                <Typography variant={'headerTitle'} color={'#262627'}>
                  Link your Annuity with Signal
                </Typography>
              </Box>
              <Box sx={{ marginTop: { xs: 1, md: 3 }, marginBottom: 2 }}>
                <Typography variant="body1Medium">
                  Missing Annuity Details
                </Typography>
              </Box>
            </>
          ) : (
            <>
              <Box sx={{}}>
                <Typography variant={'headerTitle'} color={'#262627'}>
                  Manually update your Annuity Details
                </Typography>
              </Box>
              {/* <Box sx={{ mt: { xs: 1, md: 4 } }}>
                <Typography variant={'body1'} color={'#495057'}>
                  Fill in the information below:
                </Typography>
              </Box> */}
            </>
          )}
        </>
      ) : (
        <>
          <Box sx={{}}>
            <Typography variant={'headerTitle'} color={'#262627'}>
              Asset Details
            </Typography>
          </Box>
          <Box sx={{ marginY: { xs: 1, md: 3 } }}>
            <Typography variant={'body1'} color={'#495057'}>
              Fill in the information below:
            </Typography>
          </Box>
        </>
      )}

      <NewBalanceSheetModalForm
        // handleClose={handleClose}
        handleResetForm={handleResetForm}
        canEdit={canEdit}
        type={type}
        name={name}
        amount={amount}
        version={version}
        id={id}
        subType={subType}
        setVersion={setVersion}
        setId={setId}
        setType={setType}
        setSubType={setSubType}
        setSubTypeClassification={setSubTypeClassification}
        subTypeClassification={subTypeClassification}
        interestRate={interestRate}
        setInterestRate={setInterestRate}
        monthlyPayment={monthlyPayment}
        setMonthlyPayment={setMonthlyPayment}
        frequency={frequency}
        setFrequency={setFrequency}
        ieStartDate={ieStartDate}
        setIeStartDate={setIeStartDate}
        setPolicyNumber={setPolicyNumber}
        policyNumber={policyNumber}
        setBalance={setBalance}
        balance={balance}
        loanEndDate={loanEndDate}
        setLoanEndDate={setLoanEndDate}
        setName={setName}
        plaidName={plaidName}
        setAmount={setAmount}
        issueDate={issueDate}
        setIssueDate={setIssueDate}
        carrier={carrier}
        setCarrier={setCarrier}
        product={product}
        setProduct={setProduct}
        anniversaryDate={anniversaryDate}
        setAnniversaryDate={setAnniversaryDate}
        signalLinked={signalLinked}
        setSignalLinked={setSignalLinked}
        typeSubTypeUuid={sortKey}
        key={sortKey}
        open={true}
        handleSubmit={handleClose}
        reloadAccounts={handleReload}
        newStyle={true}
        handleClose={onClose}
        isAdmin={isAdmin}
        signalForm={signalForm}
        signalError={signalError}
      />
    </Box>,
    // LIABILITY NO EDIT
    <Box key="5" sx={{ padding: { xs: 2, md: 6, lg: 6 } }}>
      <Box sx={{}}>
        <Typography variant={'headerTitle'} color={'#262627'}>
          Liability Details
        </Typography>
      </Box>
      <Box sx={{ marginY: { xs: 2, md: 3 } }}>
        <Typography variant={'body1'} color={'#495057'}>
          Fill in the information below:
        </Typography>
      </Box>

      <NewBalanceSheetModalForm
        // handleClose={handleClose}
        handleResetForm={handleResetForm}
        canEdit={canEdit}
        type={type}
        name={name}
        amount={amount}
        version={version}
        id={id}
        subType={subType}
        setVersion={setVersion}
        setId={setId}
        setType={setType}
        setSubType={setSubType}
        setSubTypeClassification={setSubTypeClassification}
        subTypeClassification={subTypeClassification}
        interestRate={interestRate}
        setInterestRate={setInterestRate}
        monthlyPayment={monthlyPayment}
        setMonthlyPayment={setMonthlyPayment}
        frequency={frequency}
        setFrequency={setFrequency}
        ieStartDate={ieStartDate}
        setIeStartDate={setIeStartDate}
        setPolicyNumber={setPolicyNumber}
        policyNumber={policyNumber}
        setBalance={setBalance}
        balance={balance}
        loanEndDate={loanEndDate}
        setLoanEndDate={setLoanEndDate}
        setName={setName}
        plaidName={plaidName}
        setAmount={setAmount}
        issueDate={issueDate}
        setIssueDate={setIssueDate}
        carrier={carrier}
        setCarrier={setCarrier}
        product={product}
        setProduct={setProduct}
        anniversaryDate={anniversaryDate}
        setAnniversaryDate={setAnniversaryDate}
        signalLinked={signalLinked}
        setSignalLinked={setSignalLinked}
        typeSubTypeUuid={sortKey}
        key={sortKey}
        open={true}
        handleSubmit={handleClose}
        reloadAccounts={handleReload}
        newStyle={true}
        handleClose={onClose}
        isAdmin={isAdmin}
        signalForm={signalForm}
      />
    </Box>,
    // INCOME OR EXPENSE
    <Box key="6" sx={{ padding: { xs: 2, md: 6, lg: 6 } }}>
      <Box>
        <Typography variant="headerTitle" color="#262627">
          Do you want to add an Income or Expense?
        </Typography>
      </Box>
      <Box sx={{ marginTop: { xs: 2, md: 6 } }}>
        <Typography variant="body1" color="#495057">
          Select one of the following:
        </Typography>
      </Box>
      <Box mt={4}>
        <Box sx={{ display: 'flex', gap: 1, textAlign: 'center' }}>
          <TileBox
            onClick={() => {
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="income" fontSize="large">
                <Savings sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Income
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setDirection(1)
              setPage(9)
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="expense" fontSize="large">
                <EventAvailable sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Expense
            </Typography>
          </TileBox>
        </Box>
      </Box>
    </Box>,
    // ADD INCOME TYPES
    <Box key="7" sx={{ padding: { xs: 1, md: 6, lg: 6 } }}>
      <Box>
        <Typography variant="headerTitle" color="#262627">
          Add an Income
        </Typography>
      </Box>
      <Box sx={{ marginTop: { xs: 1, md: 4 } }}>
        <Typography variant="body1" color="#495057">
          Select which Income type you want to add:
        </Typography>
      </Box>
      <Box mt={4}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
            gap: 1,
            textAlign: 'center',
          }}
        >
          <TileBox
            onClick={() => {
              setType('income')
              setSubType('salary')
              setName('Salary')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="anothersalary" fontSize="large">
                <Work sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Another Salary
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('income')
              setSubType('militarypension')
              setName('Military Pension')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="militarypension" fontSize="large">
                <HealthAndSafety sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Military Pension
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('income')
              setSubType('vadisability')
              setName('VA Disability')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="vadisability" fontSize="large">
                <Flag sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              VA Disability
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('assetIncome')
              setSubType('property')
              setSubTypeClassification('rentalproperty')
              setName('Rental Property')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="rentalincome" fontSize="large">
                <Home sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Rental Income
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('assetIncome')
              setSubType('investment')
              setSubTypeClassification('annuity')
              setName('Annuity')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="incomeannuity" fontSize="large">
                <Paid sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Income Annuity
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('income')
              setSubType('otherincome')
              setName('Other')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="otherincome" fontSize="large">
                <Help sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Other Income
            </Typography>
          </TileBox>
        </Box>
        <Box mt={3}>
          <Button
            variant="parcoRounded"
            color="outline"
            onClick={() => {
              setPage(9)
            }}
          >
            Add an Expense Instead
          </Button>
        </Box>
      </Box>
    </Box>,
    // INCOME NO EDIT
    <Box key="8" sx={{ padding: { xs: 1, md: 6, lg: 6 } }}>
      <Box sx={{}}>
        <Typography variant={'headerTitle'} color={'#262627'}>
          Income Details
        </Typography>
      </Box>
      <Box sx={{ marginY: { xs: 1, md: 3 } }}>
        <Typography variant={'body1'} color={'#495057'}>
          Fill in the information below:
        </Typography>
      </Box>

      <NewBalanceSheetModalForm
        // handleClose={handleClose}
        handleResetForm={handleResetForm}
        canEdit={canEdit}
        type={type}
        name={name}
        amount={amount}
        version={version}
        id={id}
        subType={subType}
        setVersion={setVersion}
        setId={setId}
        setType={setType}
        setSubType={setSubType}
        setSubTypeClassification={setSubTypeClassification}
        subTypeClassification={subTypeClassification}
        interestRate={interestRate}
        setInterestRate={setInterestRate}
        monthlyPayment={monthlyPayment}
        setMonthlyPayment={setMonthlyPayment}
        frequency={frequency}
        setFrequency={setFrequency}
        ieStartDate={ieStartDate}
        setIeStartDate={setIeStartDate}
        setPolicyNumber={setPolicyNumber}
        policyNumber={policyNumber}
        setBalance={setBalance}
        balance={balance}
        loanEndDate={loanEndDate}
        setLoanEndDate={setLoanEndDate}
        setName={setName}
        plaidName={plaidName}
        setAmount={setAmount}
        issueDate={issueDate}
        setIssueDate={setIssueDate}
        carrier={carrier}
        setCarrier={setCarrier}
        product={product}
        setProduct={setProduct}
        anniversaryDate={anniversaryDate}
        setAnniversaryDate={setAnniversaryDate}
        signalLinked={signalLinked}
        setSignalLinked={setSignalLinked}
        typeSubTypeUuid={sortKey}
        key={sortKey}
        open={true}
        handleSubmit={handleClose}
        reloadAccounts={handleReload}
        newStyle={true}
        handleClose={onClose}
        isAdmin={isAdmin}
        signalForm={signalForm}
      />
    </Box>,
    // ADD EXPENSE TYPES
    <Box key="9" sx={{ padding: { xs: 1, md: 6, lg: 6 } }}>
      <Box>
        <Typography variant="headerTitle" color="#262627">
          Add an Expense
        </Typography>
      </Box>
      <Box sx={{ marginTop: { xs: 1, md: 4 } }}>
        <Typography variant="body1" color="#495057">
          Select which Expense type you want to add:
        </Typography>
      </Box>
      <Box mt={4}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
            gap: 1,
            textAlign: 'center',
          }}
        >
          <TileBox
            onClick={() => {
              setType('expense')
              setSubType('creditcard')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="creditcard" fontSize="large">
                <CreditCard sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Credit Card
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('expense')
              setSubType('autoloan')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="autoloan" fontSize="large">
                <CarRental sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Auto Loan
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('expense')
              setSubType('paydayloan')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="personalloan" fontSize="large">
                <Paid sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Personal Loan
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('expense')
              setSubType('privatestudentloan')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="studentloan" fontSize="large">
                <School sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Student Loan
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('expense')
              setSubType('primarymortgage')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="mortgage" fontSize="large">
                <Home sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Mortgage
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setType('expense')
              setSubType('other')
              handleNext()
            }}
          >
            <Box className="icon-circle" sx={iconCircleStyle}>
              <Icon aria-label="otherexpense" fontSize="large">
                <Help sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant="body3Weird" color="#262627">
              Other Expense
            </Typography>
          </TileBox>
        </Box>
        <Box mt={3}>
          <Button
            variant="parcoRounded"
            color="outline"
            onClick={() => {
              setPage(7)
            }}
          >
            Add an Income Instead
          </Button>
        </Box>
      </Box>
    </Box>,
    // LIABILITY NO EDIT
    <Box key="10" sx={{ padding: { xs: 2, md: 6, lg: 6 } }}>
      <Box sx={{}}>
        <Typography variant={'headerTitle'} color={'#262627'}>
          Expense Details
        </Typography>
      </Box>
      <Box sx={{ marginY: { xs: 2, md: 3 } }}>
        <Typography variant={'body1'} color={'#495057'}>
          Fill in the information below:
        </Typography>
      </Box>

      <NewBalanceSheetModalForm
        // handleClose={handleClose}
        handleResetForm={handleResetForm}
        canEdit={canEdit}
        type={type}
        name={name}
        amount={amount}
        version={version}
        id={id}
        subType={subType}
        setVersion={setVersion}
        setId={setId}
        setType={setType}
        setSubType={setSubType}
        setSubTypeClassification={setSubTypeClassification}
        subTypeClassification={subTypeClassification}
        interestRate={interestRate}
        setInterestRate={setInterestRate}
        monthlyPayment={monthlyPayment}
        setMonthlyPayment={setMonthlyPayment}
        frequency={frequency}
        setFrequency={setFrequency}
        ieStartDate={ieStartDate}
        setIeStartDate={setIeStartDate}
        setPolicyNumber={setPolicyNumber}
        policyNumber={policyNumber}
        setBalance={setBalance}
        balance={balance}
        loanEndDate={loanEndDate}
        setLoanEndDate={setLoanEndDate}
        setName={setName}
        plaidName={plaidName}
        setAmount={setAmount}
        issueDate={issueDate}
        setIssueDate={setIssueDate}
        carrier={carrier}
        setCarrier={setCarrier}
        product={product}
        setProduct={setProduct}
        anniversaryDate={anniversaryDate}
        setAnniversaryDate={setAnniversaryDate}
        signalLinked={signalLinked}
        setSignalLinked={setSignalLinked}
        typeSubTypeUuid={sortKey}
        key={sortKey}
        open={true}
        handleSubmit={handleClose}
        reloadAccounts={handleReload}
        newStyle={true}
        handleClose={onClose}
        isAdmin={isAdmin}
        signalForm={signalForm}
      />
    </Box>,
    // ANNUITY LINKED WITH SIGNAL
    <Box key="11" sx={{ padding: { xs: 2, md: 6, lg: 6 } }}>
      <Box sx={{}}>
        <Typography variant={'headerTitle'} color={'#262627'}>
          Will this Annuity be linked with Signal?
        </Typography>
      </Box>
      <Box sx={{ marginTop: { xs: 2, md: 6 } }}>
        <Typography variant={'body1'} color={'#495057'}>
          Select one of the following:
        </Typography>
      </Box>
      <Box mt={4}>
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            textAlign: 'center',
          }}
        >
          <TileBox
            onClick={() => {
              handleNext()
            }}
          >
            <Box
              className="icon-circle"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#f9f9f9',
                borderRadius: 200,
                padding: '5px',
                mb: 1,
              }}
            >
              <img
                src={signalLogo}
                style={{
                  width: '42px',
                  height: '42px',
                  borderRadius: '50%',
                }}
              />
            </Box>
            <Typography variant={'body3Weird'} color={'#262627'}>
              Link with Signal
            </Typography>
          </TileBox>

          <TileBox
            onClick={() => {
              setDirection(1)
              setPage(4)
            }}
          >
            <Box
              className="icon-circle"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#f9f9f9',
                borderRadius: 200,
                padding: 1,
                mb: 1,
              }}
            >
              <Icon aria-label="institution" fontSize="large">
                <HistoryEdu sx={{ color: '#262627' }} />
              </Icon>
            </Box>
            <Typography variant={'body3Weird'} color={'#262627'}>
              Enter Manually
            </Typography>
          </TileBox>
        </Box>
      </Box>
    </Box>,
    // SINGAL POLICY NUMBER
    <Box key="12" sx={{ padding: { xs: 2, md: 6, lg: 6 } }}>
      <Box sx={{}}>
        <Typography variant={'headerTitle'} color={'#262627'}>
          What is the Annuity Policy Number?
        </Typography>
      </Box>
      <Box sx={{ marginTop: { xs: 2, md: 6 } }}>
        <Typography variant={'body1'} color={'#495057'}>
          At PARCO we call this your Account Number. In order for the linking to
          work, PARCO had to have set up the annuity for this client.
        </Typography>
      </Box>
      <Box mt={4}>
        <Box>
          {renderMuiFormField({
            id: 'policyNumber',
            label: 'Policy Number',
            placeholder: '12345678',
            inputType: 'text',
            value: policyNumber,
            onChange: setPolicyNumber,
          })}
        </Box>
        <Box
          display={'flex'}
          flexDirection="row"
          justifyContent="space-between"
          mt={6}
        >
          <Button
            variant="parcoRounded"
            color="outline"
            onClick={() => {
              setPage(4)
            }}
          >
            Enter Manually Instead
          </Button>
          <Button
            variant="parcoRounded"
            color="signal"
            onClick={getSignalPolicyInfo}
          >
            {isLoading && (
              <CircularProgress
                size="30px"
                color="inherit"
                sx={{ marginRight: '8px' }}
              />
            )}{' '}
            Link with Signal
          </Button>
        </Box>
      </Box>
    </Box>,
    // DEDUCTIONS
    <Box key="13" sx={{ padding: { xs: 2, md: 6, lg: 6 } }}>
      <Box sx={{}}>
        <Typography variant={'headerTitle'} color={'#262627'}>
          Deduction Details
        </Typography>
      </Box>
      <Box sx={{ marginY: { xs: 2, md: 3 } }}>
        <Typography variant={'body1'} color={'#495057'}>
          Fill in the information below:
        </Typography>
      </Box>

      <NewBalanceSheetModalForm
        // handleClose={handleClose}
        handleResetForm={handleResetForm}
        canEdit={canEdit}
        type={type}
        name={name}
        amount={amount}
        version={version}
        id={id}
        subType={subType}
        setVersion={setVersion}
        setId={setId}
        setType={setType}
        setSubType={setSubType}
        setSubTypeClassification={setSubTypeClassification}
        subTypeClassification={subTypeClassification}
        interestRate={interestRate}
        setInterestRate={setInterestRate}
        monthlyPayment={monthlyPayment}
        setMonthlyPayment={setMonthlyPayment}
        keepInRetirement={keepInRetirement}
        setKeepInRetirement={setKeepInRetirement}
        frequency={frequency}
        setFrequency={setFrequency}
        ieStartDate={ieStartDate}
        setIeStartDate={setIeStartDate}
        setPolicyNumber={setPolicyNumber}
        policyNumber={policyNumber}
        setBalance={setBalance}
        balance={balance}
        loanEndDate={loanEndDate}
        setLoanEndDate={setLoanEndDate}
        setName={setName}
        plaidName={plaidName}
        setAmount={setAmount}
        issueDate={issueDate}
        setIssueDate={setIssueDate}
        carrier={carrier}
        setCarrier={setCarrier}
        product={product}
        setProduct={setProduct}
        anniversaryDate={anniversaryDate}
        setAnniversaryDate={setAnniversaryDate}
        signalLinked={signalLinked}
        setSignalLinked={setSignalLinked}
        typeSubTypeUuid={sortKey}
        key={sortKey}
        open={true}
        handleSubmit={handleClose}
        reloadAccounts={handleReload}
        newStyle={true}
        handleClose={onClose}
        isAdmin={isAdmin}
        signalForm={signalForm}
      />
    </Box>,
    // TSP LOAN NO EDIT
    <Box key="14" sx={{ padding: { xs: 2, md: 6, lg: 6 } }}>
      <Box>
        <Typography variant="headerTitle" color="#262627">
          TSP Loan Details
        </Typography>
      </Box>
      <Box sx={{ marginY: { xs: 2, md: 3 } }}>
        <Typography variant="body1" color="#495057">
          Fill in the information below:
        </Typography>
      </Box>

      <NewBalanceSheetModalForm
        handleClose={onClose}
        handleResetForm={handleResetForm}
        canEdit={canEdit}
        type="liability"
        name={name || 'TSP Loan'}
        amount={amount}
        version={version}
        id={id}
        subType="tspLoan"
        setVersion={setVersion}
        setId={setId}
        setType={setType}
        setSubType={setSubType}
        setSubTypeClassification={setSubTypeClassification}
        subTypeClassification={
          subTypeClassification || 'tspLoan-generalpurpose'
        }
        interestRate={interestRate}
        setInterestRate={setInterestRate}
        monthlyPayment={monthlyPayment}
        setMonthlyPayment={setMonthlyPayment}
        loanEndDate={loanEndDate}
        setLoanEndDate={setLoanEndDate}
        setName={setName}
        setAmount={setAmount}
        typeSubTypeUuid={sortKey}
        key={sortKey}
        open={true}
        handleSubmit={handleClose}
        reloadAccounts={handleReload}
        newStyle={true}
      />
    </Box>,
  ]

  return (
    <>
      <Dialog
        open
        onClose={onClose}
        TransitionComponent={Transition}
        fullWidth
        maxWidth={'md'}
        PaperProps={{
          sx: {
            overflow: { xs: 'auto', sm: 'visible' },
            margin: '16px',
            width: 'calc(100% - 32px)',
            marginTop: 'max(20vh, 58px)',
            alignSelf: 'flex-start',
            marginBottom: '64px',
          },
        }}
      >
        <Box
          sx={{
            justifyContent: 'space-between',
            position: 'relative',
            display: 'flex',
            top: { xs: 8, sm: -48 },
          }}
        >
          {page > 0 && page !== 6 && page !== 11 && page !== 13 && page !== 14 && (
            <IconButton
              onClick={handleBack}
              sx={{
                position: 'absolute',
                top: 0,
                left: { xs: 8, sm: 0 },
                color: '#fff',
                zIndex: 1,
                backgroundColor: '#000',
                '&:hover': {
                  backgroundColor: '#000',
                },
              }}
            >
              <ArrowBack />
            </IconButton>
          )}

          <IconButton
            onClick={onClose}
            sx={{
              position: 'absolute',
              top: 0,
              right: { xs: 8, sm: 0 },
              color: '#fff',
              zIndex: 1,
              backgroundColor: '#000',
              '&:hover': {
                backgroundColor: '#000',
              },
            }}
          >
            <Close />
          </IconButton>
        </Box>
        {/* add box to hide the overflow on transition */}
        <Box sx={{ overflowY: 'auto', overflowX: 'hidden' }}>
          <DialogContent
            sx={{ overflow: 'visible', paddingTop: { xs: '40px', sm: '16px' } }}
          >
            <motion.div
              key="accounts"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.3, ease: 'easeInOut' }}
            >
              <AnimatePresence mode="wait" custom={direction}>
                <motion.div
                  key={page}
                  custom={direction}
                  variants={variants}
                  initial="enter"
                  animate="center"
                  exit="exit"
                  transition={{ duration: 0.3 }}
                  style={{
                    position: 'relative',
                    width: '100%',
                  }}
                >
                  {pages[page]}
                </motion.div>
              </AnimatePresence>
            </motion.div>
          </DialogContent>
        </Box>
      </Dialog>
    </>
  )
}
